// Module
var code = "<template>\n</template>";
// Exports
export default code;